import { render, staticRenderFns } from "./ReplicacaoTransportadora.vue?vue&type=template&id=e25d9304"
import script from "./ReplicacaoTransportadora.vue?vue&type=script&lang=js"
export * from "./ReplicacaoTransportadora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports